import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Note } from '@cna/projects/ak-jura/shared/interfaces';
import { ModalComponent } from '../modal/modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocxCreatorService } from '../../../../../../../../angular/file-creation/src/lib/docx-creator.service';
import { Observable } from 'rxjs/Observable';
import { CourseParticipation } from '../../../../../../shared/interfaces/src/lib/data-management/course/course-participation';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { AskDeleteModalComponent } from '../ask-delete-modal/ask-delete-modal.component';
import { selectCustomersCourseParticipation } from '../../../../../../../../../apps/ak-jura/frontends/my-ak-jura/src/app/+state/course_participation/selectors';
import { LearningModuleDocumentInfo } from '../../../../../../shared/interfaces/src/lib/learning-module-document-info';

@Component({
    selector: 'cna-notes-accordion',
    templateUrl: './notes-accordion.component.html',
    styleUrls: ['./notes-accordion.component.scss'],
})
export class NotesAccordionComponent implements OnInit, OnChanges {
    @Input() notes: Note[];
    @Input() moduleName: string;
    @Input() moduleId: string;
    @Input() notesOverview: boolean;
    @Input() moduleDocumentInfo?: LearningModuleDocumentInfo;
    private destroy$ = new Subject();
    private repSectionIndexById = new Map<string, number>();
    noteToBeEdited: Note;
    Modal;

    courseParticipation$: Observable<CourseParticipation> = this.store
        .select(selectCustomersCourseParticipation) //
        .pipe(takeUntil(this.destroy$));

    constructor(
        private store: Store,
        private modalService: NgbModal,
        private docxCreatorService: DocxCreatorService
    ) {}

    ngOnInit(): void {}

    ngOnChanges(): void {
        this.rebuildRepSectionIndexById();
    }

    getRepSectionDisplayIndex(note: Note, noteIndex: number): string {
        const sectionId = note?.sectionId as string;
        if (sectionId && this.repSectionIndexById.has(sectionId)) {
            return String(this.repSectionIndexById.get(sectionId));
        }
        return String(noteIndex + 1);
    }

    private rebuildRepSectionIndexById(): void {
        this.repSectionIndexById.clear();
        const chapters = this.moduleDocumentInfo?.chapters ?? [];
        let sectionIndex = 1;

        chapters.forEach(chapter => {
            (chapter.sections ?? []).forEach(section => {
                if (section?.id) {
                    this.repSectionIndexById.set(
                        section.id as string,
                        sectionIndex
                    );
                }
                sectionIndex++;
            });
        });
    }

    open(event, clickedNote: Note) {
        event.preventDefault();
        event.stopPropagation();

        switch (event.target.id) {
            case 'edit':
                this.Modal = ModalComponent;
                break;
            case 'close':
                this.Modal = AskDeleteModalComponent;
                break;
            default:
                break;
        }

        const modalRef = this.modalService.open(this.Modal, {
            backdrop: true,
            size: 'lg',
            keyboard: true,
            centered: true,
            windowClass: 'custom-modal',
        });

        modalRef.componentInstance.id = clickedNote.id;
        modalRef.componentInstance.title = clickedNote.title;
        if (this.Modal === ModalComponent) {
            modalRef.componentInstance.content = clickedNote.description;
        }
    }

    exportNotes(notes: Note[]) {
        let course;
        this.courseParticipation$.subscribe(c => {
            course = c.bookedCourse.description;
        });
        this.docxCreatorService.createFromNotes(
            notes,
            this.moduleName,
            course,
            this.moduleDocumentInfo
        );
    }
}
